import script from "./info-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./info-card.vue?vue&type=script&setup=true&lang=ts"

import "./info-card.vue?vue&type=style&index=0&id=7f5fcb0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5fcb0c"]])

export default __exports__